import type { LanguageLocalesEnum } from 'js/src/client';
import type { SelectOption } from 'js/src/components/common/ui/Select/types';

export const TRANSLATIONS_ACTIONS = {
    STORE_TRANSLATIONS: 'STORE_TRANSLATIONS',
    STORE_SUPPORTED_LANGUAGES: 'STORE_SUPPORTED_LANGUAGES',
    STORE_LOADING_SUPPORTED_LANGUAGES: 'STORE_LOADING_SUPPORTED_LANGUAGES',
};

export type TranslationSelectValue = SelectOption<LanguageLocalesEnum>;
